'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { GeoforgeLogoWithText } from '@/components/icons/geoforge-logo-with-text';
import { Button } from '@/components/ui/button';

export default function Error({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-[430px] rounded-lg bg-white px-10 py-8">
        <GeoforgeLogoWithText className="mx-auto" />

        <div className="mt-8 text-center">
          <h3 className="text-balance text-lg">{error.message}</h3>
          <p className="mt-4 text-sm text-gray-500">
            We encountered an unexpected error. Please try again or contact support if the problem
            persists.
          </p>

          <Button asChild className="mt-8 w-full">
            <Link href="/my-maps">Go to my maps</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
